import { Navigate } from 'react-router-dom';

/** Legacy route — play series is a tab on Play events. */
export default function PlayEventSeriesPage() {
  return <Navigate to="/admin/play-events?tab=series" replace />;
}
